module.exports = __webpack_public_path__ + "static/media/file-archive.cebaa5b2.svg";